<div class="p-4 md:p-6 max-w-7xl mx-auto">
  <!-- Encabezado -->
  <div class="mb-5">
    <h1 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
      <mat-icon>groups</mat-icon>
      Registro de beneficiarios
    </h1>
    <p class="text-sm text-gray-500 mt-1">
      Consulta de solo lectura. Busca por RUT, correo o ID — desde el cliente
      hacia sus beneficiarios, o desde un beneficiario hacia su cliente.
    </p>
  </div>

  <!-- Toggle de modo -->
  <div class="inline-flex rounded-lg border border-gray-200 bg-white p-1 mb-4">
    <button
      type="button"
      class="px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1"
      [class.bg-green-600]="modo === 'cliente'"
      [class.text-white]="modo === 'cliente'"
      [class.text-gray-600]="modo !== 'cliente'"
      (click)="setModo('cliente')"
    >
      <mat-icon class="!text-base !w-4 !h-4">person_search</mat-icon>
      Buscar cliente
    </button>
    <button
      type="button"
      class="px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1"
      [class.bg-green-600]="modo === 'beneficiario'"
      [class.text-white]="modo === 'beneficiario'"
      [class.text-gray-600]="modo !== 'beneficiario'"
      (click)="setModo('beneficiario')"
    >
      <mat-icon class="!text-base !w-4 !h-4">badge</mat-icon>
      Buscar beneficiario
    </button>
  </div>

  <!-- Barra de búsqueda -->
  <form
    class="flex flex-col md:flex-row gap-3 md:items-end mb-6"
    (ngSubmit)="buscar()"
  >
    <div class="flex-1">
      <label class="block text-xs font-medium text-gray-500 mb-1">
        {{ modo === 'cliente' ? 'RUT, correo, nombre o ID del cliente' : 'RUT, correo, nombre o cuenta del beneficiario' }}
      </label>
      <input
        type="text"
        [(ngModel)]="q"
        name="q"
        placeholder="Escribe y presiona Buscar…"
        class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
      />
    </div>

    <div *ngIf="modo === 'beneficiario'">
      <label class="block text-xs font-medium text-gray-500 mb-1">Origen</label>
      <select
        [(ngModel)]="origen"
        name="origen"
        class="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        <option value="">Todos</option>
        <option *ngFor="let o of origenes" [value]="o.value">{{ o.label }}</option>
      </select>
    </div>

    <button
      type="submit"
      class="bg-green-600 hover:bg-green-700 text-white rounded-lg px-5 py-2 text-sm font-medium flex items-center gap-1 justify-center disabled:opacity-50"
      [disabled]="loading"
    >
      <mat-icon class="!text-base !w-4 !h-4">search</mat-icon>
      Buscar
    </button>
  </form>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-10">
    <mat-progress-spinner mode="indeterminate" diameter="40" color="primary"></mat-progress-spinner>
  </div>

  <!-- ─── Modo cliente: tabla de usuarios ─── -->
  <div *ngIf="!loading && modo === 'cliente' && buscado" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-gray-500 text-left">
          <tr>
            <th class="px-4 py-3 font-medium">ID</th>
            <th class="px-4 py-3 font-medium">Nombre</th>
            <th class="px-4 py-3 font-medium">Documento</th>
            <th class="px-4 py-3 font-medium">Correo</th>
            <th class="px-4 py-3 font-medium">Estado</th>
            <th class="px-4 py-3 font-medium text-right">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usuarios" class="border-t border-gray-100 hover:bg-gray-50">
            <td class="px-4 py-3 text-gray-700">{{ u.usuarioId }}</td>
            <td class="px-4 py-3 text-gray-800">{{ u.nombre }} {{ u.apellidos }}</td>
            <td class="px-4 py-3 text-gray-600">{{ u.tipoId }} {{ u.numeroId }}</td>
            <td class="px-4 py-3 text-gray-600">{{ u.email }}</td>
            <td class="px-4 py-3">
              <span
                class="px-2 py-0.5 rounded-full text-xs font-medium"
                [class.bg-green-100]="u.activo"
                [class.text-green-700]="u.activo"
                [class.bg-gray-100]="!u.activo"
                [class.text-gray-500]="!u.activo"
              >{{ u.activo ? 'Activo' : 'Inactivo' }}</span>
            </td>
            <td class="px-4 py-3 text-right">
              <button
                type="button"
                class="text-green-600 hover:text-green-800 text-sm font-medium inline-flex items-center gap-1"
                (click)="verBeneficiarios(u)"
              >
                <mat-icon class="!text-base !w-4 !h-4">visibility</mat-icon>
                Ver beneficiarios
              </button>
            </td>
          </tr>
          <tr *ngIf="usuarios.length === 0">
            <td colspan="6" class="px-4 py-8 text-center text-gray-400">
              Sin resultados para “{{ q }}”.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ─── Modo beneficiario: tabla de beneficiarios ─── -->
  <div *ngIf="!loading && modo === 'beneficiario' && buscado" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-gray-500 text-left">
          <tr>
            <th class="px-4 py-3 font-medium">Origen</th>
            <th class="px-4 py-3 font-medium">Beneficiario</th>
            <th class="px-4 py-3 font-medium">Documento / Correo</th>
            <th class="px-4 py-3 font-medium">Destino</th>
            <th class="px-4 py-3 font-medium">Banco / Medio</th>
            <th class="px-4 py-3 font-medium">Cliente dueño</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of beneficiarios" class="border-t border-gray-100 hover:bg-gray-50">
            <td class="px-4 py-3">
              <span class="inline-flex items-center gap-1 text-gray-700">
                <mat-icon class="!text-base !w-4 !h-4 text-gray-400">{{ origenIcon(b.origen) }}</mat-icon>
                {{ origenLabel(b.origen) }}
              </span>
            </td>
            <td class="px-4 py-3 text-gray-800">{{ b.nombre }} {{ b.apellidos }}</td>
            <td class="px-4 py-3 text-gray-600">
              <div *ngIf="b.numeroId">{{ b.numeroId }}</div>
              <div *ngIf="b.email" class="text-xs text-gray-400">{{ b.email }}</div>
              <div *ngIf="b.telefono" class="text-xs text-gray-400">{{ b.telefono }}</div>
            </td>
            <td class="px-4 py-3 text-gray-600 font-mono">{{ b.destino || '—' }}</td>
            <td class="px-4 py-3 text-gray-600">{{ b.banco || '—' }}</td>
            <td class="px-4 py-3">
              <div *ngIf="b.dueno; else sinDueno" class="text-gray-800">
                {{ b.dueno.nombre }} {{ b.dueno.apellidos }}
                <div class="text-xs text-gray-400">
                  ID {{ b.dueno.usuarioId }} · {{ b.dueno.numeroId }}
                </div>
              </div>
              <ng-template #sinDueno><span class="text-gray-400">—</span></ng-template>
            </td>
          </tr>
          <tr *ngIf="beneficiarios.length === 0">
            <td colspan="6" class="px-4 py-8 text-center text-gray-400">
              Sin resultados para “{{ q }}”.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Paginación -->
  <div
    *ngIf="!loading && buscado && metaActual && metaActual.total > 0"
    class="flex items-center justify-between mt-3 text-sm text-gray-500"
  >
    <span>
      {{ metaActual.total }} resultado(s) · página {{ metaActual.page }} de {{ metaActual.totalPages }}
    </span>
    <div class="flex gap-2">
      <button
        type="button"
        class="px-3 py-1 rounded border border-gray-300 disabled:opacity-40"
        [disabled]="metaActual.page <= 1"
        (click)="paginar(-1)"
      >Anterior</button>
      <button
        type="button"
        class="px-3 py-1 rounded border border-gray-300 disabled:opacity-40"
        [disabled]="metaActual.page >= metaActual.totalPages"
        (click)="paginar(1)"
      >Siguiente</button>
    </div>
  </div>

  <!-- ─── Drill-down: beneficiarios del cliente seleccionado ─── -->
  <div *ngIf="drillUsuario" class="mt-6 bg-white rounded-lg border border-gray-200">
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
      <div>
        <h2 class="font-semibold text-gray-800">
          Beneficiarios de {{ drillUsuario.nombre }} {{ drillUsuario.apellidos }}
        </h2>
        <p class="text-xs text-gray-400">
          ID {{ drillUsuario.usuarioId }} · {{ drillUsuario.numeroId }}
          <span *ngIf="drill"> · {{ drill.total }} beneficiario(s)</span>
        </p>
      </div>
      <button type="button" class="text-gray-400 hover:text-gray-600" (click)="cerrarDrill()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="drillLoading" class="flex justify-center py-8">
      <mat-progress-spinner mode="indeterminate" diameter="32" color="primary"></mat-progress-spinner>
    </div>

    <div *ngIf="drill && !drillLoading" class="p-4">
      <p *ngIf="drill.total === 0" class="text-center text-gray-400 py-6">
        Este cliente no tiene beneficiarios registrados.
      </p>

      <div *ngFor="let o of origenes" class="mb-5">
        <ng-container *ngIf="drill.porOrigen[o.value].length > 0">
          <h3 class="text-sm font-semibold text-gray-600 flex items-center gap-1 mb-2">
            <mat-icon class="!text-base !w-4 !h-4 text-gray-400">{{ o.icon }}</mat-icon>
            {{ o.label }}
            <span class="text-gray-400 font-normal">({{ drill.porOrigen[o.value].length }})</span>
          </h3>
          <div class="overflow-x-auto border border-gray-100 rounded-lg">
            <table class="min-w-full text-sm">
              <thead class="bg-gray-50 text-gray-500 text-left">
                <tr>
                  <th class="px-3 py-2 font-medium">Beneficiario</th>
                  <th class="px-3 py-2 font-medium">Documento / Correo</th>
                  <th class="px-3 py-2 font-medium">Destino</th>
                  <th class="px-3 py-2 font-medium">Banco / Medio</th>
                  <th class="px-3 py-2 font-medium">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of drill.porOrigen[o.value]" class="border-t border-gray-100">
                  <td class="px-3 py-2 text-gray-800">{{ b.nombre }} {{ b.apellidos }}</td>
                  <td class="px-3 py-2 text-gray-600">
                    <div *ngIf="b.numeroId">{{ b.numeroId }}</div>
                    <div *ngIf="b.email" class="text-xs text-gray-400">{{ b.email }}</div>
                    <div *ngIf="b.telefono" class="text-xs text-gray-400">{{ b.telefono }}</div>
                  </td>
                  <td class="px-3 py-2 text-gray-600 font-mono">{{ b.destino || '—' }}</td>
                  <td class="px-3 py-2 text-gray-600">{{ b.banco || '—' }}</td>
                  <td class="px-3 py-2">
                    <div class="flex flex-wrap items-center gap-1.5">
                      <span
                        class="px-2 py-0.5 rounded-full text-xs font-medium"
                        [class.bg-green-100]="b.activo"
                        [class.text-green-700]="b.activo"
                        [class.bg-gray-100]="!b.activo"
                        [class.text-gray-500]="!b.activo"
                      >{{ b.activo ? 'Activo' : 'Inactivo' }}</span>

                      <!-- Solo Vita: estado AML + acción de re-verificación. -->
                      <ng-container *ngIf="o.value === 'vita'">
                        <span
                          *ngIf="b.vitaEstado === 'ok'"
                          class="px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700"
                        >Vita OK</span>
                        <span
                          *ngIf="b.vitaEstado === 'banned'"
                          class="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700"
                        >Vita bloqueado</span>

                        <button
                          type="button"
                          (click)="refrescarVita(b)"
                          [disabled]="esRefrescandoVita(b)"
                          class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          title="Volver a consultar el estado en Vita"
                        >
                          <mat-icon class="!text-sm !w-3.5 !h-3.5">refresh</mat-icon>
                          {{ esRefrescandoVita(b) ? 'Verificando…' : 'Re-verificar' }}
                        </button>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
